import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, ICrudGetAllAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './auth-user-import.reducer';
import { IAuthUserImport } from 'app/shared/model/auth-user-import.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAuthUserImportProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const AuthUserImport = (props: IAuthUserImportProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { authUserImportList, match, loading } = props;
  return (
    <div>
      <h2 id="auth-user-import-heading">
        <Translate contentKey="examsysApp.authUserImport.home.title">Auth User Imports</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="examsysApp.authUserImport.home.createLabel">Create new Auth User Import</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {authUserImportList && authUserImportList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.authUserImport.tel">Tel</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.authUserImport.createDate">Create Date</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.authUserImport.startDate">Start Date</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.authUserImport.endDate">End Date</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.authUserImport.code">Code</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {authUserImportList.map((authUserImport, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${authUserImport.id}`} color="link" size="sm">
                      {authUserImport.id}
                    </Button>
                  </td>
                  <td>{authUserImport.tel}</td>
                  <td>
                    {authUserImport.createDate ? (
                      <TextFormat type="date" value={authUserImport.createDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {authUserImport.startDate ? (
                      <TextFormat type="date" value={authUserImport.startDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {authUserImport.endDate ? (
                      <TextFormat type="date" value={authUserImport.endDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{authUserImport.code}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${authUserImport.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${authUserImport.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${authUserImport.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="examsysApp.authUserImport.home.notFound">No Auth User Imports found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ authUserImport }: IRootState) => ({
  authUserImportList: authUserImport.entities,
  loading: authUserImport.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuthUserImport);
